import {
	Container,
	ContainerGutter,
	ContainerPadding,
	Image,
	Text,
	TextTag,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useOfertaCard } from '../../../context/ofertas-card-context';
import { getEtiquetaDgt } from '../../../helpers/ofertas-helper';
import { CarlineWithOfertas, Oferta } from '../../../services/ofertas-service/models/ofertas';
import { OfertaPromotionLabel } from '../oferta-promotion-label';

export const OfertaCardTitleMobile = ({
	carline,
	currentOferta,
}: {
	carline: CarlineWithOfertas;
	currentOferta: Oferta;
}): React.ReactElement => {
	const { handleLayerOnClick, setSelectedPromotion } = useOfertaCard();
	return (
		<Container
			data-testid="oferta-card-title-mobile"
			wrap={'always'}
			horizontalAlign={'space-between'}
			verticalAlign={'center'}
			stretchContent
		>
			{currentOferta.promociones && (
				<OfertaPromotionLabel
					handleLayerOnClick={handleLayerOnClick}
					promociones={currentOferta.promociones}
					setSelectedPromotion={setSelectedPromotion}
				/>
			)}

			<Container data-testid="title-dgt-mobile" verticalAlign={'center'} gutter={ContainerGutter.static200} wrap="auto">
				<Text tag={TextTag.h3} appearance={TokenTextAppearance.headline400} bold>
					{carline.nuevo ? 'Nuevo ' : ''}
					{currentOferta.carline?.salesgroup?.title}
				</Text>
				{currentOferta.configuracion.etiquetaDGT && (
					<Image
						src={currentOferta.configuracion.etiquetaDGT && getEtiquetaDgt(currentOferta.configuracion.etiquetaDGT)}
						alt={carline.title}
						width={24}
						height={24}
					/>
				)}
			</Container>

			<Container
				padding={{
					top: ContainerPadding.static100,
				}}
			>
				<Text appearance={TokenTextAppearance.label200} wordBreak>
					{currentOferta.configuracion.motorizacion.name}
				</Text>
			</Container>
		</Container>
	);
};
